import { render, staticRenderFns } from "./PetStep.vue?vue&type=template&id=1f9c57fd&scoped=true&"
import script from "./PetStep.vue?vue&type=script&lang=js&"
export * from "./PetStep.vue?vue&type=script&lang=js&"
import style0 from "./PetStep.vue?vue&type=style&index=0&id=1f9c57fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c57fd",
  null
  
)

export default component.exports